import { BREAKDOWN_QUERY_KEYS } from "@domains/reviews/client/components/breakdown/breakdownQueryState.ts";

export const COMPARISON_QUERY_KEYS = [...BREAKDOWN_QUERY_KEYS, "compare"] as const;
